import { gql } from '@apollo/client/core';

// Persisted in-app notifications (#224). The bell used to be a live-only
// Pinia list fed by the `userNotification` subscription, so read-state and the
// badge reset on every reload; these operations back it with the server.

export const MY_NOTIFICATIONS = gql`
  query MyNotifications($first: Int, $page: Int, $unread_only: Boolean) {
    myNotifications(first: $first, page: $page, unread_only: $unread_only) {
      data {
        id
        title
        message
        type
        metadata
        read_at
        created_at
      }
      paginatorInfo {
        currentPage
        lastPage
        total
        hasMorePages
      }
    }
  }
`;

export const MY_UNREAD_NOTIFICATION_COUNT = gql`
  query MyUnreadNotificationCount {
    myUnreadNotificationCount
  }
`;

export const MARK_NOTIFICATION_READ = gql`
  mutation MarkNotificationRead($id: ID!) {
    markNotificationRead(id: $id)
  }
`;

export const MARK_ALL_NOTIFICATIONS_READ = gql`
  mutation MarkAllNotificationsRead {
    markAllNotificationsRead
  }
`;
